import { render, staticRenderFns } from "./PermissionToggle.vue?vue&type=template&id=7aa32622&scoped=true"
import script from "./PermissionToggle.vue?vue&type=script&lang=js"
export * from "./PermissionToggle.vue?vue&type=script&lang=js"
import style0 from "./PermissionToggle.vue?vue&type=style&index=0&id=7aa32622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa32622",
  null
  
)

export default component.exports